import { gql } from "@apollo/client";

export const AMBASSADOR_CERTIFICATE_FIELDS = gql`
  fragment AmbassadorCertificateFields on AmbassadorCertificate {
    id
    firstname
    lastname
    date
    author {
      id
      name
      type
    }
    responsible
    college {
      id
      name
      title
      status
      certified
      parentGroups {
        id
        name
        title
        logo {
          id
          title
          filename
          filesize
          filetype
          url
        }
      }
    }
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_AMBASSADOR_CERTIFICATE = gql`
  query AmbassadorCertificate($id: ID!) {
    certAmbassadorCertificate(id: $id) {
      ...AmbassadorCertificateFields
    }
  }
  ${AMBASSADOR_CERTIFICATE_FIELDS}
`;

export const GET_AMBASSADOR_CERTIFICATES = gql`
  query AmbassadorCertificates(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetAmbassadorCertificatesOrderByClause]
  ) {
    certAmbassadorCertificates(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...AmbassadorCertificateFields
      }
    }
  }
  ${AMBASSADOR_CERTIFICATE_FIELDS}
`;
